import { render } from "./location_career.vue?vue&type=template&id=2b5382a4&ts=true"
import script from "./location_career.vue?vue&type=script&lang=ts"
export * from "./location_career.vue?vue&type=script&lang=ts"

import "./location_career.vue?vue&type=style&index=0&id=2b5382a4&lang=scss"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__